module.exports = __webpack_public_path__ + "img/pandora.b3d3a997.png";